export default "/images/search_icon_hy.svg?a22246206c48a24ecbcb3765b2e715b1";